import React from "react";

const ITEMS = [
  "PIPE", "VALVES", "FITTINGS", "GASKETS", "STUD BOLTS", "BLINDS",
  "HARDWARE", "FASTENERS", "PLYWOOD", "WOOD STUDS", "NAILS", "FLANGES",
];

export const Marquee = () => {
  const strip = [...ITEMS, ...ITEMS];
  return (
    <section className="py-6 md:py-8 border-y border-border bg-card overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {strip.map((t, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-display font-extrabold uppercase text-3xl md:text-5xl tracking-tight text-foreground/90 px-6">
              {t}
            </span>
            <span className="text-accent text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
